<template lang="pug">
  .smokeWrapper
    //- .smoke
    .smoke2
    //- .smoke3
    //- .smoke4
</template>

<script>
export default {
  name: 'topSmoke',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @keyframes smoke2Animation {
    0%{left:0%;}
    50%{left:-100%;}
    100%{left:0%;}
  }
  @keyframes smoke3Animation {
    0%{left:0%;}
    50%{left:-100%;}
    100%{left:0%;}
  }
  @keyframes smoke4Animation {
    0%{right:0%;}
    50%{right:-100%;}
    100%{right:0%;}
  }
  .smoke, .smoke2, .smoke3, .smoke4{
    width:100%;
    height:400px;
    background-image: url('/img/smoke2.png');
    background-size:cover;
    position: absolute;
    top:0;
  }
  .smoke{
    // display:none;
    height:300px;
  }
  .smoke2{
    animation:smoke2Animation 200s infinite;
    width:200%;
    // height:300px;
    left:0;
    // display:none;
  }
  .smoke3{
    animation:smoke3Animation 100s infinite;
    width:200%;
    // height:200px;
    left:0;
    transform: scaleX(-1);
    // display:none;
  }
  .smoke4{
    animation:smoke4Animation 50s infinite;
    width:200%;
    right:0;
  }
  .smokeWrapper{
    width:100%;
    height:400px;
    z-index:-1;
    position: absolute;
    top:0px;
    overflow:hidden;
    transform:rotate(180deg);
  }
  @media(max-width:968px){
  .smokeWrapper{
      height:100px;
    }
  }
  @media(max-width:768px){
    .smokeWrapper{
      height:100px;
    }
  }
</style>
